/* global $ CAMERAS_URL */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import { livecamClickTracker } from '../../actions/currentItem';
import { fetchRelatedSnapshotFeed, relatedSnapshotsMounted } from '../../actions/relatedSnapshots';
import { fetchAndSetCamerasApiToken } from '../../actions/auth';
import { isArrayEqual } from '../../utils';
import { Loader } from '../';

import './styles.scss';
import RelatedSnapshot from './RelatedSnapshot';

class RelatedSnapshotsCarousel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      paginationText: '',
      initialOrder: [],
      wsReconnectAttempts: 0,
      hlsMap: {},
    };

    this.onSetCurrentItemByFeed = this.onSetCurrentItemByFeed.bind(this);
    this.startHls = this.startHls.bind(this);
    this.onStreamsResponse = this.onStreamsResponse.bind(this);
    this.sortRelatedSnapshots = this.sortRelatedSnapshots.bind(this);
  }

  componentWillMount() {
    if (this.props.camGroupId) {
      this.props.dispatch(fetchRelatedSnapshotFeed(this.props.camGroupId));
    }
  }

  componentWillReceiveProps(nextProps) {
    const { cameraToken } = nextProps;
    if (!cameraToken) {
      console.log('no token set');
      this.props.dispatch(fetchAndSetCamerasApiToken());
    }
    if (nextProps.relatedSnapshots.length && (!_.isEqual(this.props.relatedSnapshots, nextProps.relatedSnapshots) ||
      !_.isEqual(this.props.cameraToken, cameraToken))) {
      const hlsStreamIds = _.compact(_.map(nextProps.relatedSnapshots, 'stream_id')) || [];

      if (cameraToken && hlsStreamIds.length > 0) {
        const hlsStreamIdString = hlsStreamIds.map(id => `q[id_in][]=${id}`)
          .join('&');
        const count = hlsStreamIds.length;
        this.startHls(`?${hlsStreamIdString}`, cameraToken, count);
      }
    }

    // Fetches new related snapshots if cam group changes
    if (this.props.camGroupId !== nextProps.camGroupId) {
      this.props.dispatch(fetchRelatedSnapshotFeed(nextProps.camGroupId, true));
      this.setState({ initialOrder: [] });
    }

    if (!isArrayEqual(this.props.relatedSnapshots, nextProps.relatedSnapshots)) {
      if (this.state.initialOrder.length === 0) {
        // HACK: We don't want to re-order the feeds if it's a user cam group or 'all livecams' group
        if (!_.get(nextProps.currentItem, 'cam_group.user', false) && parseInt(_.get(nextProps.currentItem, 'cam_group.id'), 10) !== 133) {
          const [live, notLive] = _.partition(nextProps.relatedSnapshots, (o) => {
            return !o.is_inactive && !o.is_meditation;
          });
          const [meditation, highlights] = _.partition(notLive, (o) => {
            return o.is_meditation;
          });
          const relatedSnapshots = live.concat(meditation, highlights);
          this.setState({ initialOrder: _.map(relatedSnapshots, 'id') });
        } else {
          this.setState({ initialOrder: _.map(nextProps.relatedSnapshots, 'id') });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isMounted && this.props.relatedSnapshots && this.props.relatedSnapshots.length > 0) {
      this.props.dispatch(relatedSnapshotsMounted());
    }
  }

  onSetCurrentItemByFeed(feed, e) {
    if ($(e.target)
      .hasClass('info-btn')) {
      e.preventDefault();
      return;
    }
    this.props.dispatch(livecamClickTracker());
    this.setState({ nowPlayingId: feed.id });
  }

  startHls(ids, token, count) {
    const countString = count > 20 ? `&per=${count}` : '';
    const url = `${CAMERAS_URL}/streams.json${ids}${countString}`;

    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(this.onStreamsResponse)
      .catch((error) => console.log(error));
  }

  onStreamsResponse({ streams }) {
    const hlsStreams = streams || [];
    const hlsMap = hlsStreams.reduce((map, obj) => {
      map[obj.id] = obj;
      return map;
    }, {});

    this.setState({ hlsMap });
  }

  sortRelatedSnapshots(relatedSnapshots) {
    const { currentItem } = this.props;
    const { initialOrder, hlsMap } = this.state;
    if (_.get(currentItem, 'cam_group.user', false) || parseInt(_.get(currentItem, 'cam_group.id'), 10) === 133) {
      return _.sortBy(relatedSnapshots, (feedSnapshot) => {
        return _.indexOf(initialOrder, feedSnapshot.id);
      });
    }

    const collection = relatedSnapshots.map((snapshot) => {
      const snapshotCopy = snapshot;

      if (Object.keys(hlsMap).length === 0) {
        snapshotCopy['isLive'] = (snapshot.is_meditation || snapshot.is_film || snapshot.is_inactive) ? 0 : 1;
        return snapshotCopy;
      }
      const hlsInfo = hlsMap[snapshot.stream_id] || {};
      const isLive = _.get(hlsMap[snapshot.stream_id], 'state', 'false');
      snapshotCopy['current_viewers'] = _.get(hlsMap[snapshot.stream_id], 'numberOfViewers', 0);
      snapshotCopy['isLive'] = (isLive === 'live') ? 1 : 0;
      return snapshotCopy;
    });
    const results = _.partition(collection, 'isLive');
    if (results.length === 1) results.push([]);
    const live = _.orderBy(results[0], 'current_viewers', 'desc');
    const offline = _.orderBy(results[1], 'current_viewers', 'desc');
    return live.concat(offline);
  }

  render() {
    const {
      relatedSnapshots: sourceSnapshots,
      currentItem,
      toggleCarousel,
      isFetching,
      isFetchingSnapshots,
      reset,
    } = this.props;
    const { hlsMap } = this.state;

    const onSetCurrentItemByFeed = this.onSetCurrentItemByFeed;
    const videoCarouselClass = (toggleCarousel) ? '' : 'carousel-hidden';

    if (!sourceSnapshots || _.isEmpty(sourceSnapshots)) {
      return null;
    }

    const relatedSnapshots = this.sortRelatedSnapshots(sourceSnapshots);

    const children = relatedSnapshots.map((relatedSnapshot) => {
      const isActive = (relatedSnapshot.id === currentItem.id);
      const hlsInfo = relatedSnapshot.force_offline ? {} : hlsMap[relatedSnapshot.stream_id];

      return (
        <VisibilitySensor
          key={`${relatedSnapshot.cam_group.id}-${relatedSnapshot.id}`}
          partialVisibility
        >
          {({ isVisible }) => (
            <RelatedSnapshot
              isActive={isActive}
              relatedSnapshot={relatedSnapshot}
              hlsInfo={hlsInfo}
              onThumbnailClick={onSetCurrentItemByFeed}
              isVisible={!toggleCarousel ? false : isVisible}
              camGroupSlug={currentItem.cam_group.slug}
            />
          )}
        </VisibilitySensor>
      );
    });

    const content = children;

    return (
      <div className="row mt-10">
        <div className="col-12">
          <div id="video-carousel" className={videoCarouselClass}>
            {
              (isFetchingSnapshots && reset) || isFetching
                ? <Loader dark />
                : content
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    camGroups: state.cam_groups.data,
    isFetchingSnapshots: state.relatedSnapshots.isFetching,
    reset: state.relatedSnapshots.reset,
    currentItem: state.currentItem.data,
    isAuthenticated: state.auth.isAuthenticated,
    userId: state.auth.userId,
    favorites: state.favorites.user,
    feedFetching: state.cam_groups.feedFetching,
    isFetching: state.cam_groups.isFetching,
    relatedSnapshots: state.relatedSnapshots.data,
    isMounted: state.relatedSnapshots.mounted,
    cameraToken: state.auth.cameraToken,
  };
};

RelatedSnapshotsCarousel.propTypes = {
  camGroupId: PropTypes.number,
  currentItem: PropTypes.shape({}).isRequired,
  isMounted: PropTypes.bool.isRequired,
  relatedSnapshots: PropTypes.array,
  isFetchingSnapshots: PropTypes.bool.isRequired,
  toggleCarousel: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

RelatedSnapshotsCarousel.contextTypes = {
  router: PropTypes.object,
};

RelatedSnapshotsCarousel.defaultProps = {
  camGroupId: null,
  camToggleText: 'Hide Other Cams',
  relatedSnapshots: {},
};

export default connect(mapStateToProps)(RelatedSnapshotsCarousel);
